import { createJSONRequest } from '../../../api/create-request'

/**
 * Get testimonials for an actor
 */
export const fetchAnnouncement = (notificationId: string) => createJSONRequest({
  method: 'GET',
  url: `/api/announcements/${notificationId}`,
})

export const fetchUserLatestCommunityAnnouncements = () => createJSONRequest({
  method: 'GET',
  url: '/api/user/latest-community-announcements',
})

export const toggleLike = (notificationId: string) => createJSONRequest({
  method: 'PUT',
  url: `/api/announcements/${notificationId}/toggle-like`,
})
